import { useRef } from "react";
import sortStyles from "../../styles/CustomSort.module.css"
import { MultiSelect } from "primereact/multiselect"
import { classNames } from "primereact/utils";

const _ = require('lodash');

/*
Example filter item definition
[
  { name: "Organization", code: "organization", direction: "ASC", enabled: false },
  { name: "Created", code: "createdAt", direction: "ASC", enabled: false },
  { name: "Due on", code: "dueOn", direction: "ASC", enabled: true },
]
*/

const CustomSort = ({ sorting, setSorting, singleSortOnly, applySorting }) => {

  const sortingApplied = useRef(true)

  function updateSorting(updatedItems, ignoreSortingApplied) {
    const updatedSorting = _.cloneDeep(sorting)

    // Process updatedItems
    updatedItems?.forEach(item => {
      // Find matching sorting options
      updatedSorting.forEach(updateItem => {
        if (item.code === updateItem.code) { // found the matching sorting option
          if (item[item.key] !== item.value) { // the value actually changed
            updateItem[item.key] = item.value

            // Set sortingApplied under the right conditions
            if ((item.key === "direction" && updateItem.enabled) || item.key === "enabled") {
              if (!ignoreSortingApplied) {
                sortingApplied.current = false
              }
            }
          }
        }
      })
    })

    setSorting(updatedSorting)
  }

  function _applySorting(override) {
    if (sortingApplied.current === false || override) {
      sortingApplied.current = true
      applySorting()
    }
  }

  const itemTemplate = (option) => {
    const iconClass = option.direction === "ASC" ? "pi pi-arrow-up" : "pi pi-arrow-down"
    return (
      <div className={sortStyles.sortItem}>
        <label className={sortStyles.sortLabel}>{option.name}</label>
        <i
          className={classNames(iconClass, sortStyles.sortDirectionIcon)}
          onClick={(e) => {
            e.stopPropagation()
            updateSorting([{ code: option.code, key: "direction", value: option.direction === "ASC" ? "DESC" : "ASC" }])
          }}
        />
      </div>
    )
  }

  const selectedItemTemplate = () => {
    const selectedSortItems = sorting.filter(item => item.enabled === true)
    return selectedSortItems.map(item => {
      const iconClass = item.direction === "ASC" ? "pi pi-arrow-up" : "pi pi-arrow-down"
      return (
        <div key={item.code} className="flex flex-wrap w-200 gap-2 items-center">
          <div className={sortStyles.filterMobileItem}>
            <label>
              {`${item?.name}`}
              <i className={classNames(iconClass, sortStyles.sortDirectionIconSmall)} />
            </label>
          </div>
        </div>
      )
    })
  }

  return (
    <div className={sortStyles.sortingWrapper}>
      <div className={`${sortStyles.headerItem} ${sortStyles.sortingItem}`}>
        <label className={sortStyles.headerLabel}>Sort by:</label>
        <MultiSelect
          placeholder="None"
          display="chip"
          value={sorting?.filter(s => s.enabled).map(item => item.code)}
          itemTemplate={itemTemplate}
          options={sorting}
          panelHeaderTemplate={<></>}
          selectedItemTemplate={
            <div className="flex flex-wrap w-full gap-2 items-center">
              {selectedItemTemplate()}
            </div>
          }
          className={sortStyles.sortItemBorder}
          optionLabel="name"
          optionValue="code"
          onChange={(e) => {

            if(e.value.length === 0) return; // Don't allow deselecting the last value

            // Filter e.value if 'singleSortOnly'
            let selectedValues = e.value
            if(singleSortOnly){
              selectedValues = [e.value[e.value.length - 1]]
            }

            let updatedItems = []
            const updatedSorting = _.cloneDeep(sorting)
            updatedSorting.forEach(item => {
              updatedItems.push({ code: item.code, key: "enabled", value: selectedValues.includes(item.code) })
            })
            updateSorting(updatedItems)
          }}
          onHide={() => {
            _applySorting()
          }}
        />
      </div>
    </div>
  )
}

export default CustomSort